import { render, staticRenderFns } from "./TheOtros.vue?vue&type=template&id=ce8d63ce&"
import script from "./TheOtros.vue?vue&type=script&lang=js&"
export * from "./TheOtros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports